import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api.js";
import type { EventStatus } from "@mma/shared";
import { EventStatusBadge } from "../components/EventStatusBadge.js";

interface EventRow {
  id: string;
  name: string;
  date: string;
  location: string | null;
  status: EventStatus;
  _count: { fights: number };
}

export function HistoryPage() {
  const [events, setEvents] = useState<EventRow[]>([]);

  useEffect(() => {
    api.get<EventRow[]>("/api/events").then(setEvents);
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-xl font-bold">Historik</h1>
        <Link to="/" className="text-sm text-neutral-400 hover:text-neutral-200">
          ← Forside
        </Link>
      </header>

      <div className="space-y-2">
        {events.map((e) => (
          <div
            key={e.id}
            className="bg-neutral-900 rounded-xl p-4 border border-neutral-800"
          >
            <div className="flex justify-between items-baseline mb-2">
              <span className="font-semibold">{e.name}</span>
              <EventStatusBadge status={e.status} />
            </div>
            <div className="text-sm text-neutral-400 mb-3">
              {new Date(e.date).toLocaleString("da-DK")}
              {e.location && ` · ${e.location}`}
              {` · ${e._count.fights} kampe`}
            </div>
            <div className="flex gap-2 flex-wrap">
              <Link
                to={`/admin/events/${e.id}`}
                className="text-xs px-3 py-2 bg-neutral-800 hover:bg-neutral-700 rounded"
              >
                Vis kampe
              </Link>
              <a
                href={`/api/export/events/${e.id}/json`}
                className="text-xs px-3 py-2 bg-neutral-800 hover:bg-neutral-700 rounded"
              >
                ⬇ JSON
              </a>
              <a
                href={`/api/export/events/${e.id}/csv`}
                className="text-xs px-3 py-2 bg-neutral-800 hover:bg-neutral-700 rounded"
              >
                ⬇ CSV
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
